import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workflowUpdate } from '@api/sdk.gen';
import { WorkflowsUpdatePayload } from '@api/types.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';
import { queryKeys as edgeStackQueryKeys } from '@/react/edge/edge-stacks/queries/query-keys';

import { workflowQueryKeys } from '../../queries/query-keys';
import { Workflow } from '../types';

type UpdateWorkflowParams = {
  id: Workflow['id'];
  payload: WorkflowsUpdatePayload;
};

async function updateWorkflow({ id, payload }: UpdateWorkflowParams) {
  const { data } = await workflowUpdate({ path: { id }, body: payload });

  return data;
}

export function useUpdateWorkflow() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateWorkflow,
    ...withError('Unable to update workflow'),
    ...withInvalidate(queryClient, [
      workflowQueryKeys.all,
      edgeStackQueryKeys.base(),
    ]),
  });
}
